import { calculateForecastAmount } from '@common/forecasting';
import { TransactionSchedulePlan } from '@common/types';
import { dt } from '@common/util/dateTime';

export const getPotentialGainsOnTargetDate = ({
    annualReturn,
    initialDepositPlan,
    targetDate,
    transactionSchedulePlans,
}: {
    annualReturn: number | null | undefined;
    initialDepositPlan: number | null | undefined;
    targetDate: string | null | undefined;
    transactionSchedulePlans: TransactionSchedulePlan[];
}): number => {
    if (!annualReturn || !targetDate) return 0;
    const startDate = dt().toDateStr();

    const amountWithReturn = calculateForecastAmount({
        transactionSchedulePlans,
        annualGrowthRate: annualReturn,
        startAmount: initialDepositPlan ?? 0,
        startDate,
        targetDate,
    });

    const amountWithoutReturn = calculateForecastAmount({
        transactionSchedulePlans,
        annualGrowthRate: 0,
        startAmount: initialDepositPlan ?? 0,
        startDate,
        targetDate,
    });

    return amountWithReturn - amountWithoutReturn;
};
